/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { createReducer, on } from '@ngrx/store';
import { ParamCategory } from '../../models/add-project-parameter-category';
import {
  GetBuiltInGroupParametersSuccess,
  GetDefinitionGroupParametersSuccess,
  GetParamCategorySuccess,
  InitializeAddProjectParametersSuccess,
} from './project-data-action';
import { ProjectParameterDataItems } from '@hcworkspace/sysque/toolbelt/feature';
import { ProjectDataParamInfo } from '../../models/add-project-data-params-info';

export const ProjectDataKey = 'ProjectData';

export interface ProjectDataState {
  paramCategory: ParamCategory[];
  initialData: ProjectParameterDataItems[];
  builtInGroupDataPramsInfo: ProjectDataParamInfo[];
  definitionGroupPramsInfo: ProjectDataParamInfo[];
}

export const initialProjectDataState: ProjectDataState = {
  paramCategory: [{ isChecked: false, name: '' }],
  initialData: [],
  builtInGroupDataPramsInfo: [],
  definitionGroupPramsInfo: [],
};

export const ProjectDataReducer = createReducer(
  initialProjectDataState,
  on(GetParamCategorySuccess, (state, action) => ({
    ...state,
    paramCategory: action.paramCategory,
  })),

  on(InitializeAddProjectParametersSuccess, (state, action) => ({
    ...state,
    initialData: action.initialProjectParameterDataItems,
  })),

  on(GetBuiltInGroupParametersSuccess, (state, action) => ({
    ...state,
    builtInGroupDataPramsInfo: action.projectDataParamInfo,
  })),

  on(GetDefinitionGroupParametersSuccess, (state, action) => ({
    ...state,
    definitionGroupPramsInfo: action.projectDataParamInfo,
  }))
);
